import {api} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        isCreated: false,
        widgetData: null,
        dirty: true,
    },
    getters: {},
    actions: {
        async fetchWidgetData({commit, rootState}) {
            const space_id = rootState.space.current_space.data.id
            try {
                const res = await api.budgets_widget.save({space_id})
                if (res.body.success) {
                    commit('updateWidgetData', res.body.data)
                }
            } catch (e) {
                console.log(e)
            }
        }
    },
    mutations: {
        updateWidgetData(state, data) {
            if (data.sumPlan === 0) {
                state.isCreated = false
            } else {
                state.isCreated = true
                state.widgetData = data
            }
            state.dirty = false
        },
        clearBudgetsWidget(state) {
            state.widgetData = null;
            state.dirty = true;
            state.isCreated = false;
        }
    }
}